import React from 'react'
import { Invoice } from '../../../interfaces/invoice'
import { useTranslation } from 'react-i18next'
import TableItems from '../../Table/TableItems'
import InvoiceFileActions from '../../Table/InvoiceFileActions'
import moment from 'moment'
import { formatPaymentMethod } from '../../../helpers/formatPaymentMethod'
import { formatPaymentStatus } from '../../../helpers/formatPaymentStatus'

interface Props {
  invoices: Invoice[]
  isLoading?: boolean
}

interface ValueType {
  value: string
}

const InvoicesTable = ({ invoices = [], isLoading }: Props) => {
  const { t } = useTranslation()

  const columns = [
    {
      Header: 'ID',
      accessor: 'id',
    },
    {
      Header: t('chargeDate'),
      accessor: 'charge_date',
      Cell: ({ value }: ValueType) => (
        <span>{moment(value).format('DD/MM/YYYY')}</span>
      ),
    },
    {
      Header: t('status'),
      accessor: 'status',
      Cell: ({ value }: ValueType) => {
        const { label, className } = formatPaymentStatus(t, value)
        return <span className={className}>{label}</span>
      },
    },
    {
      Header: t('billingPeriod'),
      Cell: (cell: { row: { original: Invoice } }) => (
        <span>
          {moment(cell.row.original.billing_period_start).format('DD/MM/YYYY')}{' '}
          - {moment(cell.row.original.billing_period_end).format('DD/MM/YYYY')}
        </span>
      ),
    },
    {
      Header: t('amount'),
      accessor: 'amount',
      Cell: ({ value }: ValueType) => <span>€{value}</span>,
    },
    {
      Header: t('method'),
      accessor: 'method',
      Cell: ({ value }: { value: Invoice['method'] }) => (
        <span>{formatPaymentMethod(t, value)}</span>
      ),
    },
    {
      id: 'actions',
      Header: ' ',
      Cell: ({ row: { original } }: { row: { original: Invoice } }) => (
        <InvoiceFileActions fileUrl={original.invoice_file} />
      ),
    },
  ]

  return (
    <TableItems
      columns={columns}
      data={invoices}
      isDataLoading={isLoading}
      noDataFoundMessage='noInvoicesFound'
      showSearch={false}
      showLastColumn={false}
    />
  )
}

export default InvoicesTable
